import {
  color,
  lineColor,
  yAxisLabelSize,
  xAxisLabelSize,
  titleTextSize,
  grid,
  intervalCount
} from "@/modules/Charts/theme.js";

let ydataOpt = {
  smooth: true,
  type: "line",
  symbolSize: 0,
};

let yAxisOpt = {
  type: "value",
  //min: 0,
  axisTick: {
    show: parseInt(bmeConfig.customerSign) == 38 ? true : false,
    inside: false,
  },
  splitLine: {
    show: false
  },
  axisLabel: {
    show: parseInt(bmeConfig.customerSign) == 38 ? true : false,
    fontSize: yAxisLabelSize,
    color,
    inside: false,
  },
  axisLine: {
    lineStyle: {
      color: lineColor
    }
  },
};
let yAxisOpt2 = {
  type: "value",
  //min: 0,
  max: function (value) {
    if (value >= 0) {
      return value.max * 2;
    } else {
      return value;
    }
  },
  axisTick: {
    show: false
  },
  splitLine: {
    show: false
  },
  axisLabel: {
    show: false,
    fontSize: yAxisLabelSize,
    color
  },
  axisLine: {
    lineStyle: {
      color: lineColor
    }
  },
};

function getOpt(xdata, ydata, params) {
  let legend = [];
  let yAxis = [];
  let colors = ["#3780D0", "#47FCFE"];
  let series = ydata.map((item, index) => {
    legend.push(item.name);
    ydataOpt.color = colors[index];

    if (index === 0) {
      yAxis.push({
        ...yAxisOpt
      });
    } else {
      yAxis.push({
        ...yAxisOpt2
      });
    }
    // console.log(item);
    if (params.isTime) {
      let sdata = [];
      sdata = xdata.map((m, n) => {
        return [
          m,
          item.data[n] && item.data[n].value,
          item.data[n] && item.data[n].unit,
        ];
      });
      item.data = JSON.parse(JSON.stringify(sdata));
    }

    return {
      ...ydataOpt,
      ...item,
      yAxisIndex: index
    };
  });
  // console.log(series);
  let w = 0;
  if (legend.length < 6) {
    w = (legend.length % 6) * 210;
  } else {
    w = 1260;
  }

  return {
    backgroundColor: "transparent",
    title: {
      show: false,
      text: (() => {
        if (!params.name) return "";
        return `{a|''}  {b|${params.name}}`;
      })(),
      top: 0,
      left: 0,
      textAlign: "left",
      textStyle: {
        color: "#fff",
        fontSize: "14",
        rich: {
          a: {
            width: 5,
            height: 21,
            color: "transparent",
            backgroundColor: {
              image: require("../../../../Charts/img/icon_gear_default.png"),
            },
          },
          b: {
            //          color:"#2CA6FF",
            fontSize: titleTextSize,
          },
        },
      },
    },
    //  color: ["#3780D0", "#47FCFE"],
    color: ["#CCD000", "#AD65E2", "#FF6F6F", "#0082FF", "#00FCFF"],
    legend: {
      selectedMode: false, //取消图例上的点击事件
      width: w + "px",
      right: "0",
      top: "0",
      itemHeight: 5,
      itemGap: 8,
      icon: "roundRect",
      textStyle: {
        color: "#fff",
        fontSize: 20,
        lineHeight: 20,
      },
      data: legend,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        lineStyle: {
          type: "dashed",
        },
      },
      position: function (point, params, dom, rect, size) {
        //    	下调tooltip 所以需要这个判断 不需要则去掉
        if (point[0] > 1450) {
          return [point[0] - 200, "15%"];
        }
        return [point[0], "15%"];
      },
      // //    position:{top: 30,left: 100},
      backgroundColor: "transparent",
      // formatter: (params) => {
      //   let str = "";
      //   params.forEach((item, i) => {
      //     str += `<div class="tooltip" style="font-size:25px;line-height:40px;">${item.name}：${item.value}</div>`;
      //   });
      //   return str;
      // },
    },
    grid,
    dataZoom: {
      show: false
    },
    xAxis: {
      boundaryGap: 0,
      type: params.isTime ? "time" : "category",
      axisTick: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: lineColor,
        },
      },
      axisLabel: {
        align: "left",
        show: false,
        color,
        fontSize: xAxisLabelSize,
        formatter: "{MM}-{dd} {HH}:{mm}",
        //      interval:intervalCount
      },
      data: xdata,
    },
    animation: false,
    yAxis,
    series,
  };
}

export default getOpt;

import {
  initOptMethod
} from "@/modules/Charts/index.js"
let getOption_ = initOptMethod(getOpt);
export {
  getOption_
};
